import styled from "styled-components";
import { TableCell, TableSortLabel } from "@mui/material";

export const StyledTableHeaderCell = styled(TableCell)`
    border: none;
    text-overflow: initial;
    overflow: initial;
`;

export const UnsortableLabel = styled.span`
    font-size: var(--size-12);
    font-weight: normal;
    color: var(--color-grey-800);
    text-transform: uppercase;
`;

export const SortableLabel = styled(TableSortLabel)<{ $active: boolean }>`
    font-size: var(--size-12);
    font-weight: normal;
    color: var(--color-grey-800);
    text-transform: uppercase;
    ${(props) =>
        props.$active &&
        `
            font-weight: bold !important;
            color:var(--color-primary) !important;
            svg {
                color: var(--color-primary) !important;
            }
  `}
`;
